import { motion } from "framer-motion";
import { PaperPlaneRight, ArrowUpRight } from "@phosphor-icons/react";
import { TELEGRAM_URL } from "@/App";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="border-t border-border bg-background relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-24 sm:pt-32">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 pb-16">
          <div>
            <span className="font-code text-xs uppercase tracking-[0.2em] text-accent">
              Get support
            </span>
            <h2 className="font-display font-bold tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl mt-5 max-w-xl">
              Need help with your account? Let&apos;s talk.
            </h2>
            <p className="font-body text-muted-foreground mt-6 max-w-md">
              Message me on Telegram with your issue. I usually reply within a
              few hours.
            </p>
          </div>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-telegram-button"
            className="inline-flex items-center gap-3 bg-accent text-accent-foreground px-9 py-5 font-code text-sm uppercase tracking-[0.15em] font-medium hover:bg-blue-500 transition-colors duration-200 group shrink-0"
          >
            @cranielz
            <PaperPlaneRight
              size={18}
              weight="fill"
              className="group-hover:translate-x-1 transition-transform duration-200"
            />
          </a>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="border-t border-border overflow-hidden"
      >
        <h3 className="font-display font-black uppercase tracking-tighter leading-none text-[22vw] text-center select-none whitespace-nowrap -mb-[2vw] pt-4">
          Craniel<span className="text-accent">.</span>
        </h3>
      </motion.div>

      <div className="border-t border-border">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-code text-xs uppercase tracking-[0.15em] text-muted-foreground">
            © {new Date().getFullYear()} Craniel — Social Platform Support
          </p>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-telegram-link"
            className="font-code text-xs uppercase tracking-[0.15em] text-muted-foreground hover:text-foreground transition-colors duration-200 inline-flex items-center gap-1"
          >
            t.me/cranielz <ArrowUpRight size={13} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
